// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2Ajf-","Primary":"Button_Primary__2Rd03","Secoundary":"Button_Secoundary__LcmFB"};